/**
 * @generated SignedSource<<abb8f4cb57d30ce17b791d146f8f5c1e>>
 * @relayHash 89a071a83d7086613e54267a83ad5589
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3e49fb6b80c74d3109cdaeee9b0845e45ba88362a09ef2d27ffccd0095c0d334

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Nav4OverviewsContentQuery$variables = {
  cloudId: string;
};
export type Nav4OverviewsContentQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"Nav4OverviewsContent">;
};
export type Nav4OverviewsContentQuery = {
  response: Nav4OverviewsContentQuery$data;
  variables: Nav4OverviewsContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "Nav4OverviewsContentQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "Nav4OverviewsContent"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Nav4OverviewsContentQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
              }
            ],
            "concreteType": "JiraWorkManagementGiraOverviewConnection",
            "kind": "LinkedField",
            "name": "jwmOverviews",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraWorkManagementGiraOverviewEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraWorkManagementGiraOverview",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "name"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "3e49fb6b80c74d3109cdaeee9b0845e45ba88362a09ef2d27ffccd0095c0d334",
    "metadata": {},
    "name": "Nav4OverviewsContentQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e24d9b35e956ee89177e09fcc3033bc6";

export default node;
